import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { ISignInRequest } from '../../../../classes/http-requests';
import { IInitializePasswordRequest } from '../../../../classes/initialize-password';
import { AppSettings } from '../../../../app.settings';
import { RSAKey } from '../../../../../globals/classes/rsa/rsaKey';
import { GoogleAnalyticsUtils } from '../../../../classes/static/google-analytics-utils';
import { UserAuth } from '../../../../classes/userAuth';
import { ErrorHandler } from '../../../../../globals/classes/errorHandler';
import { IErrorDescription } from '@ibank-globals/error';
import { Extensions } from '../../../../classes/static/extensions';
import {
	ITwoFactorAuthenticationInfo,
	TwoFactorAuthenticationInfo,
} from '../../../../classes/http-responses';
import { TwoFAModalComponent } from '../../../two-fa-modal/two-fa-modal.component';
import { finalize } from 'rxjs/operators/finalize';
import { SelfBlockedModalComponent } from '../../../self-blocked-modal/self-blocked-modal.component';

@Component({
	selector: 'restore-submition',
	template: require('./restore-submition.component.html'),
})
export class RestoreSubmitionComponent {
	@Input() isNewUser: boolean;
	@Input() isEmailUnlockUser: boolean = false;
	@Input() passwordRecoveryMethod: string;
	@Input() initRequest: IInitializePasswordRequest;
	@Input() public isLoginBigModalEnabled: boolean = false;
	public isRebrading = AppSettings.isRebrading;
	public isLoading: boolean;
	private request: ISignInRequest;
	public isBlockUserEnabled: boolean = AppSettings.isBlockUserFeature;
	constructor(
		private activeModal: NgbActiveModal,
		private modalService: NgbModal,
		private _router: Router,
		private route: ActivatedRoute
	) {
		this.initializeSignInRequest();

		this.route.queryParams.subscribe((params) => {
			this.request.returnUrl = Extensions.getReturnUrl(params)
				? Extensions.getReturnUrl(params)
				: Extensions.returnUrl;
			Extensions.returnUrl = this.request.returnUrl;
		});
	}

	closeModal(): void {
		this.activeModal.close();
	}

	public navigate() {
		let urlSecurityInfo = this._router.createUrlTree(['security-information']);
		let baseUrl = window.location.href.replace(this._router.url, '');
		window.open(baseUrl + urlSecurityInfo, '_blank');
	}

	public performLogin(provider?: string) {
		if (!provider) {
			if (!this.initRequest || !this.initRequest.passwordNew) return;
			this.isLoading = true;
			this.request.username = this.initRequest.userID;
			this.request.rememberLogin = false;

			if (AppSettings.enforcePasswordEncryption) {
				//this.request.password = rsaHelper.encryptPassword(Globals.getPropertyN(), Globals.getPropertyE(), this.password);
				let rsaKey = new RSAKey();
				rsaKey.setPublic(AppSettings.getPropertyN(), AppSettings.getPropertyE());
				this.request.password = rsaKey.encrypt(this.initRequest.passwordNew);
			} else {
				this.request.password = this.initRequest.passwordNew;
			}

			GoogleAnalyticsUtils.sendLoginEvent();

			UserAuth.signIn(this.request)
				.pipe(finalize(() => (this.isLoading = false)))
				.subscribe(
					(result) => this.handleSignInResponse(result),
					(error) => {
						if (error.desc === 'Self-locked user' && this.isBlockUserEnabled)
							this.toggleSelfBlockedhModal();
						else this.handleError(error);
					}
				);
		} else {
			alert('This option is not available yet!');
		}
	}

	private toggleSelfBlockedhModal() {
		const modalRef = this.modalService.open(SelfBlockedModalComponent, {
			windowClass: 'modal-xs',
		});
	}

	private handleSignInResponse(response: ITwoFactorAuthenticationInfo) {
		this.isLoading = false;
		if (!response) return;
		this.goToCodeVerification(response);
	}

	private goToCodeVerification(twofaInfo: ITwoFactorAuthenticationInfo): void {
		const modalRef = this.modalService.open(TwoFAModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as TwoFAModalComponent).twoFAInfo =
			new TwoFactorAuthenticationInfo(twofaInfo);
	}

	private handleError(error: IErrorDescription) {
		this.isLoading = false;
		ErrorHandler.newError(error);
	}

	private initializeSignInRequest() {
		this.request = {
			username: undefined,
			password: undefined,
			rememberLogin: undefined,
			returnUrl: undefined,
			userID: undefined,
		};
	}
}
